// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlaySquareOutlinedSvg from "@fishx/icons-svg/es/asn/PlaySquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PlaySquareOutlined = function PlaySquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareOutlinedSvg
  }));
};

PlaySquareOutlined.displayName = 'PlaySquareOutlined';
export default React.forwardRef(PlaySquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlaySquareOutlined.js
// module id = 3812
// module chunks = 0